export default __webpack_public_path__ + "static/media/arrow-up.124bf4ff.svg";